import { useMutation, useQueryClient } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';
import { getDefaultThemeStyle } from 'helpers/defaultThemes.jsx';
import useOrgId from 'hooks/useOrgId.js';

const getStyle = () => ({
  general: getDefaultThemeStyle('general'),
  generalV2: getDefaultThemeStyle('generalV2'),
});

const useCreateVodThemeMutation = (options) => {
  const firebase = useFirebase();
  const orgId = useOrgId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ name = 'Untitled Shoppable Videos theme', style: sourceStyle } = {}) => {
      const style = sourceStyle || getStyle();

      const agent = await firebase.getAgent();
      return agent.post('/themes').send({ name, orgId, style, product: 'vod' });
    },
    onSuccess: (data, variables, contexts) => {
      queryClient.invalidateQueries(['vod-themes', orgId]);
      options?.onSuccess?.(data, variables, contexts);
    },
    ...options,
  });
};

export default useCreateVodThemeMutation;
